import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { getProcessStatusBySessionId, getScanBySessionId } from '../../services/scanSession.service';
import { ScanSession } from '../../types/ScanSession';
import { ProcessStatus } from '../../types/ProcessStatus';
import { BaseApiResponse } from '../../types/BaseApiResponse';

interface ScanSessionState {
  scanSession?: ScanSession | null;
  isScanSessionLoading: boolean;
  processStatus?: ProcessStatus;
}

const initialState: ScanSessionState = {
  scanSession: null,
  isScanSessionLoading: false,
  processStatus: undefined,
};

export const fetchScanSessionBySessionId = createAsyncThunk(
  'scanSession/getScanBySessionId',
  async (sessionId: string) => await getScanBySessionId(sessionId)
);

export const fetchProcessStatusBySessionId = createAsyncThunk(
  'scanSession/getProcessStatusBySessionId',
  async (sessionId: string) => await getProcessStatusBySessionId(sessionId)
);

export const scanSessionSlice = createSlice({
  name: 'scanSession',
  initialState,
  reducers: {
    updateScanSessionState: (state, action: PayloadAction<ScanSession | null>) => {
      state.scanSession = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchProcessStatusBySessionId.fulfilled, (state, action: PayloadAction<BaseApiResponse<ProcessStatus>>) => {
      state.processStatus = action.payload.data;
    });
  },
});

export const { updateScanSessionState } = scanSessionSlice.actions;
export default scanSessionSlice.reducer;
